import { PrintBasicInfoTableLayout } from "../../../layout";

type Props = {
	reservationID: string;
};

export const BasicInfoReservationIDOfPrintComposition = ({ reservationID }: Props) => {
	return <PrintBasicInfoTableLayout title="予約番号" content={reservationID} />;
};
